import { NewsCategory } from '@fe-news/constants/categories';

export type AiArticleType = 'headline' | 'tw_stock' | 'us_stock';

type AiArticleSource = 'US_Stock_Summary' | 'TW_Stock_Summary' | 'Headline_Summary';

export type GETv1AiArticlesResponse = {
  source: AiArticleSource;
  summary: string;
  created_at: number;
  related: RelativeNews;
  title: string;
};

export type GETv1AiArticlesReturnResponse = {
  source: AiArticleSource;
  summary: string;
  createdAt: number;
  related: RelativeNews;
  title: string;
};

export const DEFAULT_AI_CONTENT = {
  title: '',
  summary: '',
  source: 'US_Stock_Summary' as AiArticleSource,
  createdAt: 0,
  related: []
};

export type ResponseAiArticleType = {
  items: GETv1AiArticlesResponse;
  message: string;
  statusCode: number;
};

export type RelativeNews = Pick<News, 'title' | 'newsId'>[];

export const AI_TABS: { category: AiArticleType; name: string }[] = [
  { category: 'headline', name: '頭條' },
  { category: 'tw_stock', name: '台股' },
  { category: 'us_stock', name: '美股' }
];

export type AiArticleTypeV2 = 'headline' | 'tw_stock' | 'us_stock';

export type GETAiArticlesResponseV2 = {
  content: string;
  feature: number;
  hasCoverPhoto: number;
  is24h: number;
  isCategoryHeadline: number;
  isIndex: number;
  isOutsource: number;
  keyword: string[];
  newsId: number;
  otherProduct: string[];
  payment: number;
  source: string;
  stock: string[];
  summary: string;
  title: string;
  video: string;
  publishAt: number;
  coverSrc: string;
  abTesting: null;
  categoryId: number;
  categoryName: string;
  columnists: null;
  magazine: null;
  fundCategoryAbbr: string[];
  fbShare: number;
  fbComment: number;
  fbCommentPluginCount: number;
  market: {
    code: string;
    name: string;
    symbol: string;
  }[];
};

export type ResponseAiArticleTypeV2 = {
  items: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
    next_page_url: string;
    prev_page_url: string;
    from: number;
    to: number;
    data: GETAiArticlesResponseV2[];
  };
  message: string;
  statusCode: number;
};

export type GETAiArticlesReturnResponseV2 = {
  items: PageData<GETAiArticlesResponseV2[]>;
  message: string;
  statusCode: number;
};

export const AI_TABS_V2: {
  category: NewsCategory.HEADLINE_AI | NewsCategory.TW_STOCK_AI | NewsCategory.WD_STOCK_AI;
  name: string;
}[] = [
  { category: NewsCategory.HEADLINE_AI, name: '頭條' },
  { category: NewsCategory.TW_STOCK_AI, name: '台股' },
  { category: NewsCategory.WD_STOCK_AI, name: '美股' }
];
